import { ScrollAnimationParent } from '@studiometa/ui';

/**
 * HeroScroll component
 *
 */
export default class HeroScroll extends ScrollAnimationParent {
  static config = {
    ...ScrollAnimationParent.config,
    name: 'HeroScroll',
    refs: [...(ScrollAnimationParent.config.refs ?? []), 'sticky', 'inner'],
  };

  /**
   * @type {number}
   */
  #lastWidth = 0;

  /**
   *
   */
  mounted() {
    this.#lockHeights();
  }

  /**
   * @param {import('@studiometa/js-toolkit').ResizedProps} props
   */
  resized(props) {
    if (props.width !== this.#lastWidth) {
      this.#lockHeights();
    }
  }

  /**
   *
   */
  #lockHeights() {
    const vh = window.innerHeight;
    this.#lastWidth = window.innerWidth;

    this.$el.style.height = `${vh * 2.4}px`;
    this.$refs.sticky.style.height = `${vh}px`;
    this.$refs.inner.style.height = `${vh}px`;
  }
}
